import "../css/GetStarted.css";

function GetStarted() {
  return (
    <div className="get-started">
      <h1>Welcome to CryptoCap</h1>
      <p>Explore the latest market trends, business insights, and trading opportunities.</p>
      <button className="explore-btn">Start Exploring</button>
    </div>
  );
}

export default GetStarted;
